import register from '@kpsys/angularjs-register';
import filtersRoutes from './filters.routes';
import {KpFiltersPresenter} from './kp-filters.presenter';


export default register('filters-page')
    .config(filtersRoutes)
    .service(KpFiltersPresenter.presenterName, KpFiltersPresenter)
    .name();